import React, {useEffect} from 'react';
import {useSearchParams} from "react-router-dom";


const Module: React.FC = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        window.location.assign(`https://portal.azure.com/#@draeger.onmicrosoft.com/resource/subscriptions/${searchParams.get("linkedId")}`);
    }, []);

    return <></>;
};

export default Module;